"use client";

import Image from "next/image";
import Contact from "./components/ContactPart";
import sanitizeDOMData from "@/utils/sanitizeDOMData";
export type INFO = {
  title: string;
  description1: string;
  title2: string;
  description2: string;
  description3: string;
  title3: string;
  phone: string;
  mail: string;
  webUrl: string;
  fb: string;
  youtube: string;
};
export default function FooterContact({ INFO }: { INFO?: INFO }) {
  if (!INFO) return null;
  return (
    <footer id="contact" className="relative overflow-x-hidden">
      {/* BACKGROUND IMAGE */}
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <Image
          src="https://images.pexels.com/photos/35298937/pexels-photo-35298937.jpeg"
          alt="bg"
          fill
          sizes="100vw"
          className="object-cover"
        />
        <div className="absolute inset-0 bg-primary/20" />
      </div>

      {/* FOOTER CARD */}
      <div className="relative max-w-7xl mx-auto px-2 md:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2  overflow-hidden shadow-2xl">
          {/* ================= LEFT – CONTACT FORM ================= */}
          <div className="bg-primary px-8 py-12 md:px-14 md:py-13">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
              {INFO.title}
            </h3>
            <div className="text-white/80 mb-10 max-w-md">
              {sanitizeDOMData(INFO.description1)}
            </div>
            <Contact />
          </div>

          {/* ================= RIGHT – INFO ================= */}
          <div className="bg-white px-8 py-12 md:px-14 md:py-16 space-y-10">
            {/* LOGO */}
            <Image
              src="/logos/logo_blue_with_name_hori.png"
              alt="orapark"
              width={180}
              height={60}
              sizes="180px"
              className="w-[180px] h-auto"
              priority
            />

            {/* INFO GRID */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm text-primary/80">
              <div>
                <p className="font-semibold text-primary mb-1">{INFO.title2}</p>
                <div>{sanitizeDOMData(INFO.description2)}</div>
              </div>

              <div>
                <div className="font-semibold text-primary mb-1">
                  {INFO.title3}
                </div>
                <p> {INFO.phone}</p>
                <p> {INFO.mail}</p>
                <p> {INFO.webUrl}</p>
              </div>
            </div>

            {/* DESCRIPTION + SOCIAL */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 items-end pt-10">
              <div className="sm:col-span-2 text-sm text-primary/70 leading-relaxed">
                {sanitizeDOMData(INFO.description3)}
              </div>

              <div className="flex gap-4 sm:justify-end">
                <a
                  href={INFO.fb}
                  className="opacity-70 hover:opacity-100 transition"
                >
                  <img
                    src="/icons/fb_icon_blue.svg"
                    className="w-6 h-6"
                    alt="fb"
                  />
                </a>
                <a
                  href={
                    INFO.youtube ||
                    "https://www.youtube.com/@OneVisionGroup-VietNam"
                  }
                  className="opacity-70 hover:opacity-100 transition"
                >
                  <img
                    src="/icons/youtube_icon_red.svg"
                    className="w-6 h-6"
                    alt="youtube"
                  />
                </a>
              </div>
            </div>

            {/* DIVIDER */}
            <div className="h-px bg-primary/20" />

            {/* COPYRIGHT */}
            <div className="text-xs text-primary/50">
              ©2025 Copyright by ZenGroup. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
